export default __webpack_public_path__ + "static/media/unavsa.ca4275b2.png";